// Phoenix backend — all routes under /api/v1
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.PROD ? "/api/v1" : "http://localhost:4000/api/v1");

// Host root — for routes outside /api/v1 (e.g. /api/health, /api/diag)
export const API_HOST_URL =
  import.meta.env.VITE_API_HOST_URL ||
  (import.meta.env.PROD ? "" : "http://localhost:4000");

// Phoenix Channels WebSocket endpoint
export const SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL ||
  (import.meta.env.PROD
    ? `${window.location.origin}/socket`
    : "ws://localhost:4000/socket");

// Resource endpoints
export const CONTACTS_API = `${API_BASE_URL}/contacts`;
export const COMPANIES_API = `${API_BASE_URL}/companies`;
export const CAMPAIGNS_API = `${API_BASE_URL}/campaigns`;
export const CALLS_API = `${API_BASE_URL}/calls`;
export const DEALS_API = `${API_BASE_URL}/deals`;
export const PIPELINES_API = `${API_BASE_URL}/pipelines`;
export const CUSTOMERS_API = `${API_BASE_URL}/customers`;
export const LISTS_API = `${API_BASE_URL}/lists`;
export const ACTIVITIES_API = `${API_BASE_URL}/activities`;
export const SCRIPTS_API = `${API_BASE_URL}/scripts`;
export const USERS_API = `${API_BASE_URL}/admin/users`;

// Reports
export const REPORTS_API_BASE = `${API_BASE_URL}/reports`;
export const REPORTS_CALLS_API = `${REPORTS_API_BASE}/calls`;
export const REPORTS_DEALS_API = `${REPORTS_API_BASE}/deals`;
export const REPORTS_AGENTS_API = `${REPORTS_API_BASE}/agents`;
